import { Card, CardContent, Typography } from '@mui/material';
import React from 'react'

const index = (props: { formValue: any }) => {

  return <div className="grid grid-cols-2 gap-3">
    <Card>
      <CardContent>
        <Typography align="center" >Basic Info</Typography>
        <Typography><span className="font-bold">Name</span>: {props.formValue?.name}</Typography>
        <Typography><span className="font-bold">Short Name</span>: {props.formValue?.shortName}</Typography>
      </CardContent>
    </Card>
    <div className="">
      <Typography align="center">Addresses</Typography>
      <div className="grid grid-cols-2 gap-2">
        {props.formValue?.addresses?.map((address: any) => (
          <Card>
            <CardContent>
              <Typography><span className="font-bold">Address Type</span>: {address?.addressType}</Typography>
              <Typography><span className="font-bold">Value</span>: {address?.value}</Typography>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  </div>;
}

export default index